import { DashboardFeatureFlagsProvider } from '@components/utils/DashboardFeatureFlags';
import { DashboardPermissionsProvider } from '@components/utils/DashboardPermissions';
import { useWebviewEventsBus } from '@contexts/WebviewEventsBusContext';
import { AppearanceProvider } from '@fourthwall/appearance';
import { AuthInitializedBoundary, AuthProvider, Protected } from '@fourthwall/auth';
import { ComponentsThemeProvider, ModalProvider, SuspenseFallback } from '@fourthwall/components';
import { SitesManagerGuardContainer } from '@fourthwall/module-sites-manager-guard';
import { onWebViewModalClose, onWebViewModalOpen } from '@fourthwall/utils';
import { ExperimentsProvider } from '@modules/App/providers/ExperimentsProvider';
import { FingerprintProvider } from '@modules/App/providers/FingerprintProvider';
import { EntriContextProvider } from '@modules/Dashboard/pages/Settings/pages/Domain/providers/Entri';
import React from 'react';
import Dashboard from '../Dashboard';
import { CurrentShopProvider } from '../ThemeEditor/providers/CurrentShopProvider';
import { CurrentShopProvider as CurrentShopProviderV2 } from '../ThemeEditorV2/providers/CurrentShopProvider';
import { API_CLIENTS } from './apiClients';
import { ForbiddenShopGuard } from './modules/forbiddenShopGuard';
import { IncorrectDomainGuard } from './modules/incorrectDomainGuard';
import { AdminModeProvider } from './providers/AdminModeProvider';
import { TagManagerProvider } from './providers/TagManagerProvider';
import { WebViewProvider } from './providers/WebViewProvider';
export const AppView = () => {
    const webviewEventBus = useWebviewEventsBus();
    const handleInitAuthSuccess = (keycloak) => {
        API_CLIENTS.forEach((client) => {
            client.addRequestInterceptor((config) => {
                keycloak.updateToken(5);
                return config;
            });
        });
    };
    const handleAuthSuccess = (keycloak) => {
        webviewEventBus.dispatchEvent('onAuthSuccess');
        const { authenticated, token, tokenParsed } = keycloak;
        if (authenticated && token && tokenParsed) {
            API_CLIENTS.forEach((client) => {
                // NOTE: `setAuthorizationHeader` needs to be called before `setUserRequest` to set the token properly.
                client.setAuthorizationHeader(token);
            });
        }
    };
    return (React.createElement(AuthProvider, { onInitAuthSuccess: handleInitAuthSuccess, onAuthSuccess: handleAuthSuccess },
        React.createElement(WebViewProvider, null,
            React.createElement(AppearanceProvider, null,
                React.createElement(AuthInitializedBoundary, { element: React.createElement(SuspenseFallback, null) },
                    React.createElement(Protected, null,
                        React.createElement(ComponentsThemeProvider, { mode: "solid" },
                            React.createElement(AdminModeProvider, null,
                                React.createElement(DashboardPermissionsProvider, null,
                                    React.createElement(SitesManagerGuardContainer, null,
                                        React.createElement(ForbiddenShopGuard, null,
                                            React.createElement(TagManagerProvider, null,
                                                React.createElement(DashboardFeatureFlagsProvider, null,
                                                    React.createElement(CurrentShopProviderV2, null,
                                                        React.createElement(CurrentShopProvider, null,
                                                            React.createElement(ExperimentsProvider, null,
                                                                React.createElement(ModalProvider, { onModalOpen: onWebViewModalOpen, onModalClose: onWebViewModalClose },
                                                                    React.createElement(IncorrectDomainGuard, null,
                                                                        React.createElement(EntriContextProvider, null,
                                                                            React.createElement(FingerprintProvider, null,
                                                                                React.createElement(Dashboard, null)))))))))))))))))))));
};
